import ic_home from '@theme/icon/ic_home.svg'
import ic_home_active from '@theme/icon/ic_home_active.svg'
import ic_game from '@theme/icon/ic_game.svg'
import ic_game_active from '@theme/icon/ic_game_active.svg'
import ic_video from '@theme/icon/ic_video.svg'
import ic_video_active from '@theme/icon/ic_video_active.svg'
import ic_account from '@theme/icon/ic_account.svg'
import ic_account_active from '@theme/icon/ic_account_active.svg'

export const NavIconMap = {
  ic_home,
  ic_home_active,
  ic_game,
  ic_game_active,
  ic_video,
  ic_video_active,
  ic_account,
  ic_account_active,
}
